import React from 'react';
import './ShimmerUi.css';

const ShimmerEffect = () => {
    return (
        <div className="installation-container">
            <main className="main-content">
                <div style={{width:'900px'}}><div class="custom-container-shimmer">
                    <div class="custom-box-shimmer"></div>
                    <div class="custom-box-shimmer"></div>
                </div>
                    <div class="custom-text-container-shimmer" style={{ display: 'flex', flexDirection: 'column', gap: '45px' }}>
                        <div class="custom-text-shimmer"></div>
                        <div class="custom-subtext-shimmer"></div>
                        <div class="custom-button-container-shimmer">
                            {/* <div class="custom-button button-1"></div> */}
                            <div class="custom-subtext-shimmer"></div>
                        </div>
                    </div>
                </div>
            </main>
        </div>


    )
}

export default ShimmerEffect